document.addEventListener('DOMContentLoaded', function () {
	// Select the main header element
	var mainHeader = document.querySelector('.text-container h1');

	if (mainHeader) {
		// Get the text content of the main header
		var mainHeaderText = mainHeader.textContent;

		// Split the text by the first space character
		var firstSpaceIndex = mainHeaderText.indexOf(' ');
		if (firstSpaceIndex !== -1) {
			var firstPart = mainHeaderText.substring(0, firstSpaceIndex);
			var secondPart = mainHeaderText.substring(firstSpaceIndex);

			// Create a span element for the second part with italic style
			var italicSpan = document.createElement('span');
			italicSpan.style.fontStyle = 'italic';
			italicSpan.textContent = secondPart;

			// Clear the main header text and append the split parts
			mainHeader.textContent = firstPart + ' ';
			mainHeader.appendChild(italicSpan);
		}
	}

	const dropdownHeaders = document.querySelectorAll('.dropdown-header');
	const dropdownImages = document.querySelectorAll('.dropdown-body-image');

	if (dropdownHeaders.length < 2) {
		return;
	}

	let currentIndex = 0;
	let isTransitioning = false;
	const intervalTime = 10000; // Interval time in milliseconds

	function closeDropdown(index) {
		return new Promise((resolve) => {
			const dropdownContent = dropdownHeaders[index].nextElementSibling;
			dropdownContent.classList.add('hidden-dropdown');

			setTimeout(() => {
				resolve();
			}, 750); // Timeout should match the CSS transition duration
		});
	}

	function openDropdown(index, _intervalTime) {
		const dropdownContent = dropdownHeaders[index].nextElementSibling;
		dropdownContent.classList.remove('hidden-dropdown');

		const imageElement =
			window.screen.width < 992
				? document.querySelector('.dd-img-mobile')
				: document.querySelector('.dd-img');
		const newImageUrl = dropdownImages[index].dataset.imageSrc;

		// Ensure the image is loaded fully before running the fade-in
		imageElement.onload = function () {
			imageElement.classList.remove('fade-out');
			imageElement.classList.add('fade-in');

			// Remove fade-in class after animation completes
			setTimeout(() => {
				imageElement.classList.remove('fade-in');
			}, 750); // Adjust to match the fade-in duration
		};

		// Trigger fade-out
		imageElement.classList.add('fade-out');

		// Wait for fade-out to complete before changing the src
		setTimeout(() => {
			imageElement.srcset = ''; // Clear the srcset attribute if exists
			imageElement.src = newImageUrl; // Update the src attribute
		}, 750); // 750ms for the fade-out duration

		addProgressBar(dropdownHeaders[index], _intervalTime);
	}

	function addProgressBar(header, _intervalTime) {
		removeProgressBar();

		const progressBar = document.createElement('div');
		progressBar.classList.add('progress-bar');
		progressBar.style.animationDuration = `${_intervalTime}ms`;
		header.appendChild(progressBar);
	}

	function removeProgressBar() {
		document
			.querySelectorAll('.dropdown-header .progress-bar')
			.forEach((bar) => bar.remove());
	}

	async function toggleDropdown() {
		if (isTransitioning) {
			return; // Prevent overlapping animations
		}

		isTransitioning = true;

		const previousIndex = currentIndex;
		currentIndex = (currentIndex + 1) % dropdownHeaders.length;

		await closeDropdown(previousIndex);
		openDropdown(currentIndex, intervalTime);

		isTransitioning = false;
	}

	// Open the first dropdown immediately when the page loads
	openDropdown(currentIndex, intervalTime + 750);

	// Set the interval to call toggleDropdown every 10 seconds
	setInterval(toggleDropdown, intervalTime); // 10000ms = 10s
});
